import AuthHeader from '@/components/Auth/AuthHeader'
import { ColorEnum } from '@/constants/color'
import { Stack } from 'expo-router'
import { FC } from 'react'

const Layout: FC = () => {
    return (
        <Stack
            screenOptions={{
                header: () => <AuthHeader />,
                contentStyle: {
                    alignItems: 'center',
                    backgroundColor: ColorEnum.JET_800,
                },
            }}
        />
    )
}

export default Layout
